export const joinList = (list: Iterable<unknown> | undefined | null): string =>
  list ? Array.from(list).join(", ") : "";
